import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { immer } from 'zustand/middleware/immer';

export interface SingleMatchStore {
	betTypeSortSettings: Array<number>;
	setBetTypeSortSettings: (betTypeSortSettings: number[]) => void;
}
export const useSingleMatchStore = createWithEqualityFn<SingleMatchStore, [['zustand/immer', never]]>(
	immer<SingleMatchStore>((set, get) => ({
		betTypeSortSettings: [],
		setBetTypeSortSettings: (betTypeSortSettings) => {
			set(params => {
				params.betTypeSortSettings = betTypeSortSettings;
			})
		}
	})),
	shallow
)